export default __webpack_public_path__ + "static/media/vs2.094dadb1.jpg";